import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { ValidateVertiRelationsFailure, ValidateVertiRelationsRequest, ValidateVertiRelationsSuccess } from './actions';
import { ValidationResponse } from '@models/swagger';

export const featureKey = 'validateVertiRelations';

export interface State {
  data: ValidationResponse | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(ValidateVertiRelationsFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(ValidateVertiRelationsRequest, state => ({ ...state, error: null, loading: true })),
    on(ValidateVertiRelationsSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
